import React from "react";

const EmptyTaskState = ({ children }) => {
  return <div className="empty-task-state">{children}</div>;
};

export default EmptyTaskState;
